import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchFlowDetails = ({
  crFlowId, crId, enabled = true,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading, isFetching, isRefetching, isError, isSuccess, data,
  } = useQuery(
    ['Fetch-Flow-Details', orgId, crId, crFlowId],
    async () => axiosInstance.get(flow(orgId).details(crFlowId, crId)),
    {
      enabled: enabled && !!crFlowId,
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      refetchOnWindowFocus: false,
    },
  );

  return {
    isLoading, isFetching, isRefetching, isError, isSuccess, data,
  };
};
